import axios from 'axios';
import { ApiOptions } from '../app-utils/GlobalObjects';

var isRefreshing = false;

export default class Api {
  constructor() {
    this.api_token = null;
    this.client = null;
    this.api_url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : window.location.origin + '/';
  }

  validateOTP = async(params) => {
    const token = sessionStorage.getItem('token');
    params['token'] = token ? token : '';
    return await this.mainRestCallService('auth/validate-otp' , 'POST' , params);
  }

  resendOTP = async() => {
    const token = sessionStorage.getItem('token');
    return await this.mainRestCallService('auth/resend-otp' , 'POST' , { token: token });
  }

  forgotPassword = async(params) => {
    return await this.mainRestCallService('auth/forgot-password' , 'POST' , params);
  }

  verifyToken = async(params) => {
    return await this.mainRestCallService('auth/verify-resettoken' , 'POST' , params);
  }

  resetPassword = async(params , url) => {
    return await this.mainRestCallService(url , 'POST' , params);
  }

  getTransactionList = async(filter) => {
    return await this.mainRestCallService('transaction' , 'GET' , filter , true);
  }

  getWalletLedger = async(filter = {}) => {
    const params = new URLSearchParams();
    const pageFilters = { index: 0, size: 10, ...filter };

    Object.keys(pageFilters).forEach(key => {
      const value = pageFilters[key];

      if (Array.isArray(value)) {
        value.forEach((item) => {
          if (item !== null && item !== undefined && item !== '') {
            params.append(key, item.toString());
          }
        });
        return;
      }

      if (value !== null && value !== undefined && value !== '') {
        params.append(key, value.toString());
      }
    });

    return await this.mainRestCallService(`consumers/transaction/wallet-ledger?${params.toString()}`, 'GET');
  }

  /**************************************************************************************
   ** mainRestCallService
   ** @param {*} apiPath : api end point
   ** @param {*} method : POST, PUT, DELETE, GET
   ** @param {*} body : request body if not send goes as null
   ** @param {*} asBody : By default true, if false goes as url params.
   ** @returns
   *************************************************************************************/
   mainRestCallService = async (apiPath, method, body = null, asParams = false) => {
    var options = ApiOptions;
    var url = this.api_url + apiPath;
    options.method = method;
    if (asParams === true) {
      const requestUrl = new URL(`${this.api_url}${apiPath}`);
      Object.keys(body).forEach(key => {
        const value = body[key];
        requestUrl.searchParams.append(key, value ? value.toString() : '');
      });
      // Keep axios/XHR integrations clone-safe by sending plain string URLs.
      url = requestUrl.toString();
    } else {
      options.body = body ? JSON.stringify(body) : null;
    }

    var result;
    if(method === 'POST'){
      result = await this.postMethod(url , body)
    } else if (method === 'GET'){
      result = await this.getMethod(url)
    } else if (method === 'PUT') {
      result = await this.putMethod(url, body)
    }

    if(result === 'session_expired'){
      window.location = '#/session-expired';
    } else if (result && result.status !== 1 && result?.error?.code !== 401) {
      return result.error?.message ?? 'Unsuccessful response';
    } else {
      return result;
    }
  }


  // get Method
  getMethod = (url) => { return axios.get(url); }

  // Post Method
  postMethod = (url , body) => { return axios.post(url , body); }

  // Put Method
  putMethod = (url , body) => { return axios.put(url , body); }

  downloadFile = async (Apiurl, fileName) => {
    const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : window.location.origin + '/';
    fetch(url + Apiurl, { method: 'GET', headers: { 'Content-Type': 'application/pdf', "Authorization": `Token ${sessionStorage.getItem('access_token')}` } })
      .then((response) => response.blob()).then((blob) => {
        const url = window.URL.createObjectURL(
          new Blob([blob]),
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download', fileName,
        );
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      });
  }

}


const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : window.location.origin + '/',
  headers: {
    "Content-Type": "application/json",
  },
});

axios.interceptors.request.use(async config => {
  const token = sessionStorage.getItem('access_token');
    if (token) { config.headers["Authorization"] = `Token ${token}`; }
    return config;
  },
  error => { return Promise.reject(error);}
);

axios.interceptors.response.use(response => {
  if (response?.data !== 'session_expired') {
    return response?.data;
  }
},
  async function (error) {
    const originalConfig = error.config;
    if (error.response?.status === 401 && isRefreshing === false && ((originalConfig?.url?.pathname?.indexOf('/login') < 0) || (originalConfig?.url?.indexOf('/login') < 0))) {
      isRefreshing = true;
      originalConfig._retry = true;
      try {
        const refreshToken = sessionStorage.getItem('refresh_token');
        const response = await instance.post("/auth/refresh", {
          token: refreshToken,
        });
        sessionStorage.setItem('access_token', response.data.data.access_token)
        sessionStorage.setItem('refresh_token', response.data.data.refresh_token)
        isRefreshing = false;
        originalConfig.headers.Authorization = `Token ${response.data.data.access_token}`
        const data = await instance(originalConfig);
        return data.data;
      } catch (_error) {
        isRefreshing = false;
        if (_error.response && _error.response.data && _error.response.data.error && _error.response.data.error.message === 'error.invalid.domain') {
          window.location = '#/invalid-domain-access';
        } else {
          window.location = '#/session-expired';
        }
      }
    } else if (error.response?.status === 400 && isRefreshing === false) {
      isRefreshing = false;
      if (error.response && error.response.data && error.response.data.error && error.response.data.error.message === 'error.invalid.domain') {
        window.location = '#/invalid-domain-access';
      }
    }
    return error.response?.data;
  }
);
